const type = [
    {
        "code":"A0001",
        "text":"餐饮",
        "children":[
            {
                "code":"B0199",
                "text":"火锅"
            },
            {
                "code":"B0001",
                "text":"中式正餐"
            },
            {
                "code":"B0002",
                "text":"西式正餐"
            },
            {
                "code":"B0003",
                "text":"日韩/东南亚菜"
            },
            {
                "code":"B0004",
                "text":"中式快餐"
            },
            {
                "code":"B0005",
                "text":"西式快餐"
            },
            {
                "code":"B0006",
                "text":"小吃/熟食"
            },
            {
                "code":"B0007",
                "text":"校园团餐"
            },
            {
                "code":"B0008",
                "text":"综合团餐"
            },
            {
                "code":"B0009",
                "text":"饮品/甜品"
            },
            {
                "code":"B0010",
                "text":"烘焙糕点"
            },
            {
                "code":"B0011",
                "text":"酒吧/清吧"
            },
            {
                "code":"B0012",
                "text":"咖啡馆/茶馆"
            },
            {
                "code":"B0200",
                "text":"宴会提供商"
            },
            {
                "code":"B0117",
                "text":"订餐服务平台"
            }
        ]
    },
    {
        "code":"A0002",
        "text":"零售批发",
        "children":[
            {
                "code":"B0013",
                "text":"杂货店"
            },
            {
                "code":"B0014",
                "text":"连锁便利店"
            },
            {
                "code":"B0015",
                "text":"大型超市"
            },
            {
                "code":"B0016",
                "text":"大卖场"
            },
            {
                "code":"B0017",
                "text":"百货商场"
            },
            {
                "code":"B0018",
                "text":"购物中心"
            },
            {
                "code":"B0019",
                "text":"奥特莱斯"
            },
            {
                "code":"B0020",
                "text":"商业街"
            },
            {
                "code":"B0021",
                "text":"水果店"
            },
            {
                "code":"B0201",
                "text":"食品零售"
            },
            {
                "code":"B0202",
                "text":"蔬菜/肉蛋/水产"
            },
            {
                "code":"B0022",
                "text":"茶叶"
            },
            {
                "code":"B0023",
                "text":"酒类"
            },
            {
                "code":"B0024",
                "text":"烟草/雪茄"
            },
            {
                "code":"B0025",
                "text":"营养品/保健品"
            },
            {
                "code":"B0026",
                "text":"服饰鞋包"
            },
            {
                "code":"B0027",
                "text":"美妆个护"
            },
            {
                "code":"B0028",
                "text":"黄金珠宝/钟表饰品"
            },
            {
                "code":"B0029",
                "text":"眼镜店"
            },
            {
                "code":"B0030",
                "text":"3C数码/家用电器"
            },
            {
                "code":"B0203",
                "text":"办公用品"
            },
            {
                "code":"B0031",
                "text":"图文音像/工美乐器"
            },
            {
                "code":"B0032",
                "text":"母婴用品/儿童玩具"
            },
            {
                "code":"B0033",
                "text":"宠物/宠物用品"
            },
            {
                "code":"B0034",
                "text":"户外运动器材"
            },
            {
                "code":"B0035",
                "text":"五金建材"
            },
            {
                "code":"B0216",
                "text":"家居家纺"
            },
            {
                "code":"B0036",
                "text":"鲜花/绿植"
            },
            {
                "code":"B0037",
                "text":"文物经营/文物复制品"
            },
            {
                "code":"B0038",
                "text":"计生用品"
            },
            {
                "code":"B0039",
                "text":"烟花爆竹"
            },
            {
                "code":"B0040",
                "text":"危险化工产品"
            },
            {
                "code":"B0041",
                "text":"石油及石油产品"
            },
            {
                "code":"B0042",
                "text":"工业产品"
            },
            {
                "code":"B0043",
                "text":"其他专业零售店"
            },
            {
                "code":"B0114",
                "text":"互联网综合电商平台"
            },
            {
                "code":"B0115",
                "text":"互联网垂直电商平台"
            },
            {
                "code":"B0118",
                "text":"社区团购服务平台"
            }
        ]
    },
    {
        "code":"A0003",
        "text":"商业生活服务",
        "children":[
            {
                "code":"B0044",
                "text":"美发/美容/美甲服务"
            },
            {
                "code":"B0045",
                "text":"洗浴/保健养生服务"
            },
            {
                "code":"B0046",
                "text":"家政/清洁服务"
            },
            {
                "code":"B0047",
                "text":"电器/家具/其他维修"
            },
            {
                "code":"B0048",
                "text":"建筑装饰/装修服务"
            },
            {
                "code":"B0049",
                "text":"地产/房屋中介代理"
            },
            {
                "code":"B0050",
                "text":"宠物医院/其他宠物服务"
            },
            {
                "code":"B0051",
                "text":"数码/娱乐设备租赁"
            },
            {
                "code":"B0052",
                "text":"无人值守自助服务"
            },
            {
                "code":"B0212",
                "text":"共享充电宝及其他共享租赁"
            },
            {
                "code":"B0213",
                "text":"无人值守自助零售"
            },
            {
                "code":"B0214",
                "text":"无人值守自助娱乐"
            },
            {
                "code":"B0053",
                "text":"婚介/婚庆/摄影服务"
            },
            {
                "code":"B0054",
                "text":"广告/会展/图文印刷"
            },
            {
                "code":"B0055",
                "text":"法律咨询/律师事务所"
            },
            {
                "code":"B0056",
                "text":"会计/金融咨询服务"
            },
            {
                "code":"B0057",
                "text":"征信和信用报告咨询服务"
            },
            {
                "code":"B0058",
                "text":"人才招聘服务"
            },
            {
                "code":"B0059",
                "text":"丧葬服务"
            },
            {
                "code":"B0060",
                "text":"拍卖/收藏"
            },
            {
                "code":"B0061",
                "text":"其他商业及生活服务"
            },
            {
                "code":"B0116",
                "text":"生活服务平台"
            },
            {
                "code":"B0112",
                "text":"在线工具"
            },
            {
                "code":"B0165",
                "text":"物业管理"
            }
        ]
    },
    {
        "code":"A0004",
        "text":"休闲娱乐",
        "children":[
            {
                "code":"B0062",
                "text":"歌舞厅/休闲会所/KTV"
            },
            {
                "code":"B0063",
                "text":"棋牌桌游/电玩网吧"
            },
            {
                "code":"B0064",
                "text":"健身房/瑜伽/舞蹈"
            },
            {
                "code":"B0065",
                "text":"院线影城/演出赛事"
            },
            {
                "code":"B0066",
                "text":"游乐园/嘉年华"
            },
            {
                "code":"B0067",
                "text":"文化场馆"
            },
            {
                "code":"B0068",
                "text":"体育场馆"
            },
            {
                "code":"B0069",
                "text":"彩票"
            },
            {
                "code":"B0070",
                "text":"其他文体娱乐"
            },
            {
                "code":"B0108",
                "text":"网络社交"
            },
            {
                "code":"B0109",
                "text":"网络图书/视频/音乐"
            },
            {
                "code":"B0110",
                "text":"游戏"
            },
            {
                "code":"B0205",
                "text":"游戏周边服务/交易平台"
            },
            {
                "code":"B0111",
                "text":"网络直播"
            }
        ]
    },
    {
        "code":"A0005",
        "text":"车主生活",
        "children":[
            {
                "code":"B0071",
                "text":"车辆零配件/用品精品"
            },
            {
                "code":"B0072",
                "text":"汽车洗美/维修养护"
            },
            {
                "code":"B0073",
                "text":"车辆销售"
            },
            {
                "code":"B0074",
                "text":"二手车销售"
            },
            {
                "code":"B0075",
                "text":"停车服务"
            },
            {
                "code":"B0076",
                "text":"代驾服务"
            },
            {
                "code":"B0077",
                "text":"电动汽车充换电"
            },
            {
                "code":"B0078",
                "text":"两轮电瓶车充换电"
            },
            {
                "code":"B0079",
                "text":"汽车租赁"
            },
            {
                "code":"B0080",
                "text":"ETC不停车自动缴费"
            },
            {
                "code":"B0081",
                "text":"MTC半自动车道收费"
            },
            {
                "code":"B0082",
                "text":"高速服务区"
            },
            {
                "code":"B0083",
                "text":"道路救援"
            }
        ]
    },
    {
        "code":"A0006",
        "text":"交通出行",
        "children":[
            {
                "code":"B0084",
                "text":"公路客运"
            },
            {
                "code":"B0085",
                "text":"出租车客运"
            },
            {
                "code":"B0086",
                "text":"网约车客运"
            },
            {
                "code":"B0087",
                "text":"地铁"
            },
            {
                "code":"B0088",
                "text":"公共交通"
            },
            {
                "code":"B0089",
                "text":"共享两轮车服务"
            },
            {
                "code":"B0090",
                "text":"加油卡、加油服务"
            },
            {
                "code":"B0091",
                "text":"加油站、加气站"
            },
            {
                "code":"B0097",
                "text":"航空公司"
            },
            {
                "code":"B0098",
                "text":"机场"
            },
            {
                "code":"B0099",
                "text":"机票代理人"
            },
            {
                "code":"B0100",
                "text":"航空系统商"
            },
            {
                "code":"B0101",
                "text":"铁路旅客运输"
            },
            {
                "code":"B0102",
                "text":"游轮及巡游航线服务"
            }
        ]
    },
    {
        "code":"A0015",
        "text":"物流运输",
        "children":[
            {
                "code":"B0092",
                "text":"物流/快递公司"
            },
            {
                "code":"B0093",
                "text":"快递服务（个人商户）"
            },
            {
                "code":"B0217",
                "text":"物流平台"
            },
            {
                "code":"B0218",
                "text":"同城即时配送"
            },
            {
                "code":"B0094",
                "text":"邮政基本服务"
            },
            {
                "code":"B0095",
                "text":"驿站/自提柜"
            },
            {
                "code":"B0096",
                "text":"仓储"
            },
            {
                "code":"B0103",
                "text":"铁路货物运输"
            },
            {
                "code":"B0104",
                "text":"船舶、海运服务提供商"
            },
            {
                "code":"B0105",
                "text":"货品停放交易（国际专用）"
            },
            {
                "code":"B0106",
                "text":"国际货运代理和报关行"
            },
            {
                "code":"B0107",
                "text":"其他运输代理业"
            }
        ]
    },
    {
        "code":"A0007",
        "text":"网络通讯",
        "children":[
            {
                "code":"B0113",
                "text":"信息检索服务/网络论坛"
            },
            {
                "code":"B0120",
                "text":"互联网数据服务"
            },
            {
                "code":"B0121",
                "text":"软件开发服务"
            },
            {
                "code":"B0122",
                "text":"数字类产品-游戏（国际专用）"
            },
            {
                "code":"B0123",
                "text":"数字类产品-软件提供商（国际专用）"
            },
            {
                "code":"B0124",
                "text":"数字类产品-其他（国际专用）"
            },
            {
                "code":"B0125",
                "text":"其他在线应用或综合类服务"
            },
            {
                "code":"B0126",
                "text":"网络推广/网络广告"
            },
            {
                "code":"B0127",
                "text":"电信运营商"
            },
            {
                "code":"B0128",
                "text":"付费电视"
            },
            {
                "code":"B0129",
                "text":"网络电话、传真服务"
            }
        ]
    },
    {
        "code":"A0008",
        "text":"教育培训",
        "children":[
            {
                "code":"B0130",
                "text":"儿童保育服务（公立，含学前教育）"
            },
            {
                "code":"B0131",
                "text":"儿童保育服务（民办，含学前教育）"
            },
            {
                "code":"B0132",
                "text":"中小学校（公立）"
            },
            {
                "code":"B0133",
                "text":"中小学校（民办）"
            },
            {
                "code":"B0134",
                "text":"大学与学院（公立）"
            },
            {
                "code":"B0135",
                "text":"大学与学院（民办）"
            },
            {
                "code":"B0136",
                "text":"其他学校/公立培训机构"
            },
            {
                "code":"B0215",
                "text":"教育管理机构"
            },
            {
                "code":"B0137",
                "text":"教育培训机构"
            },
            {
                "code":"B0138",
                "text":"少年宫及青少年发展中心"
            },
            {
                "code":"B0139",
                "text":"其他教育/培训"
            }
        ]
    },
    {
        "code":"A0009",
        "text":"医疗卫生",
        "children":[
            {
                "code":"B0140",
                "text":"医药销售"
            },
            {
                "code":"B0141",
                "text":"医疗器械销售"
            },
            {
                "code":"B0142",
                "text":"保健辅助治疗器材"
            },
            {
                "code":"B0143",
                "text":"公立医院"
            },
            {
                "code":"B0144",
                "text":"社区卫生服务中心"
            },
            {
                "code":"B0145",
                "text":"专业公共卫生机构"
            },
            {
                "code":"B0146",
                "text":"民营医院"
            },
            {
                "code":"B0147",
                "text":"诊所"
            },
            {
                "code":"B0148",
                "text":"个体医生"
            },
            {
                "code":"B0149",
                "text":"医疗美容"
            },
            {
                "code":"B0150",
                "text":"眼科医疗服务"
            },
            {
                "code":"B0151",
                "text":"口腔医疗服务"
            },
            {
                "code":"B0152",
                "text":"医学实验室及诊断中心"
            },
            {
                "code":"B0153",
                "text":"线上医疗服务"
            },
            {
                "code":"B0154",
                "text":"护理机构服务"
            },
            {
                "code":"B0155",
                "text":"体检/健康咨询"
            },
            {
                "code":"B0156",
                "text":"其他医疗保健服务"
            }
        ]
    },
    {
        "code":"A0010",
        "text":"酒旅景区",
        "children":[
            {
                "code":"B0157",
                "text":"酒店/旅馆/民宿"
            },
            {
                "code":"B0158",
                "text":"景区"
            },
            {
                "code":"B0159",
                "text":"旅行社和旅游服务"
            },
            {
                "code":"B0160",
                "text":"旅游相关服务直销"
            },
            {
                "code":"B0219",
                "text":"风景区系统商"
            },
            {
                "code":"B0220",
                "text":"观光车"
            },
            {
                "code":"B0221",
                "text":"游船码头"
            },
            {
                "code":"B0119",
                "text":"旅游服务平台（OTA）"
            }
        ]
    },
    {
        "code":"A0011",
        "text":"生活缴费",
        "children":[
            {
                "code":"B0161",
                "text":"公共事业（电、气、水）"
            },
            {
                "code":"B0204",
                "text":"公共事业-电力缴费"
            },
            {
                "code":"B0211",
                "text":"公共事业-煤气缴费"
            },
            {
                "code":"B0206",
                "text":"公共事业-自来水缴费"
            },
            {
                "code":"B0162",
                "text":"公共事业-有线电视缴费"
            },
            {
                "code":"B0207",
                "text":"公共事业-清洁服务缴费"
            },
            {
                "code":"B0163",
                "text":"公共事业-其他缴费"
            },
            {
                "code":"B0164",
                "text":"话费充值与缴费"
            }
        ]
    },
    {
        "code":"A0012",
        "text":"金融理财",
        "children":[
            {
                "code":"B0166",
                "text":"金融机构"
            },
            {
                "code":"B0167",
                "text":"金融机构-其他服务"
            },
            {
                "code":"B0168",
                "text":"外币汇兑"
            },
            {
                "code":"B0169",
                "text":"股票基金服务"
            },
            {
                "code":"B0170",
                "text":"小贷公司"
            },
            {
                "code":"B0171",
                "text":"借贷消费平台"
            },
            {
                "code":"B0172",
                "text":"融资租赁公司"
            },
            {
                "code":"B0173",
                "text":"金融租赁公司"
            },
            {
                "code":"B0174",
                "text":"汽车金融公司"
            },
            {
                "code":"B0175",
                "text":"消费金融公司"
            },
            {
                "code":"B0176",
                "text":"信托公司"
            },
            {
                "code":"B0177",
                "text":"支付机构"
            },
            {
                "code":"B0178",
                "text":"融资担保公司"
            },
            {
                "code":"B0179",
                "text":"其他金融服务"
            },
            {
                "code":"B0180",
                "text":"保险业务/保险代理"
            },
            {
                "code":"B0181",
                "text":"典当"
            }
        ]
    },
    {
        "code":"A0013",
        "text":"公共管理和社会组织",
        "children":[
            {
                "code":"B0182",
                "text":"政府机构"
            },
            {
                "code":"B0183",
                "text":"行政费用和罚款（非税）"
            },
            {
                "code":"B0184",
                "text":"公积金"
            },
            {
                "code":"B0185",
                "text":"公安交管"
            },
            {
                "code":"B0186",
                "text":"医保"
            },
            {
                "code":"B0187",
                "text":"社会保障服务"
            },
            {
                "code":"B0188",
                "text":"政府采购"
            },
            {
                "code":"B0222",
                "text":"文体机构"
            },
            {
                "code":"B0189",
                "text":"政府贷款"
            },
            {
                "code":"B0190",
                "text":"法庭费用"
            },
            {
                "code":"B0191",
                "text":"保释金"
            },
            {
                "code":"B0192",
                "text":"税务"
            },
            {
                "code":"B0193",
                "text":"慈善和社会公益服务"
            },
            {
                "code":"B0194",
                "text":"使领馆"
            },
            {
                "code":"B0195",
                "text":"行业协会和专业社团"
            },
            {
                "code":"B0196",
                "text":"汽车协会"
            },
            {
                "code":"B0197",
                "text":"宗教组织"
            },
            {
                "code":"B0198",
                "text":"其他会员组织"
            }
        ]
    }
]
export default{
    type
}